export default __webpack_public_path__ + "static/media/fall.15f03ce6.svg";